<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Manufacture Summary Weekly</h4>
                        <div class="form-inline">
                            <span><b>Type:</b></span>
                            <select v-model="typeData" class="form-control ml-2">
                                <option v-for="i in manufactureTypeList" :key="i.id" :value="i.id">{{ i.name }}</option>
                            </select>
                            <span><b>Date:</b></span>
                            <datetime v-model="date" format="dd/MM/yyyy" class="form-control ml-2" value-zone="local" zone="local"></datetime>
                            <button type="button" class="btn btn-sm  btn-hard-primary waves-light waves-effect" @click="refreshAll">
                              <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                            </button>
                            <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <i class="fa fa-print" aria-hidden="true"></i> Print
                            </button>
                            <div class="dropdown-menu" aria-labelledby="print">
                              <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                              <a class="dropdown-item" href="javascript:void(0)" @click="print('excel_product')">Excel Product</a>
                              <a class="dropdown-item" href="javascript:void(0)" @click="print('excel_material')">Excel Material</a>
                            </div>
                            <!-- <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery" /> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-list">
                    <div class="card-body">
                        <ul class="nav nav-tabs nav-bordered">
                          <li class="nav-item"><a href="#product" data-toggle="tab" aria-expanded="false" class="nav-link">Product</a></li>
                          <li class="nav-item"><a href="#material" data-toggle="tab" aria-expanded="false" class="nav-link active">Material</a></li>
                        </ul>
                        <div class="tab-content">
                          <div class="tab-pane" id="product">
                              <div class="table-responsive">
                                  <table class="table table-item mb-0 table-sm table-striped table-hover">
                                    <thead>
                                      <tr>
                                          <th>Product</th>
                                          <th class="text-center">Uom</th>
                                          <!-- <th class="text-center">Saldo Awal</th> -->
                                          <th v-for="(d, index) in period2" :key="index" class="text-center">
                                              <b>{{ d.day }}</b> {{ d.date | dateFormat('DD/MM') }}
                                          </th>
                                          <!-- <th class="text-center">Adjust +-</th> -->
                                          <th class="text-center">Saldo Akhir</th>
                                          <th>#</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="d in filterData2" :key="d.id">
                                            <td><b>[{{ d.product_no}}]</b> {{ d.product }}</td>
                                            <td class="text-center">{{ d.uom_id }}</td>
                                            <!-- <td class="text-center">{{ d.saldo_awal | currency }}</td> -->
                                            <td v-for="(a, index) in d.date_summary" :key="index" class="text-center">
                                                {{ a.qty | currency }}
                                            </td>
                                            <!-- <td class="text-center">{{ d.adjust | currency }}</td> -->
                                            <td class="text-center">{{ d.qty | currency }}</td>
                                            <td>
                                            </td>
                                        </tr>
                                    </tbody>
                                  </table>
                              </div>
                          </div>
                          <div class="tab-pane active" id="material">
                              <div class="table-responsive">
                                  <table class="table table-item mb-0 table-sm table-striped table-hover">
                                      <thead>
                                          <tr>
                                              <th>Product</th>
                                              <th class="text-center">Uom</th>
                                              <th class="text-center">Saldo Awal</th>
                                              <th class="text-center">Purchase</th>
                                              <th v-for="(d, index) in period" :key="index" class="text-center">
                                                  <b>{{ d.day }}</b> {{ d.date | dateFormat('DD/MM') }}
                                              </th>
                                              <th class="text-center">Total Pemakaian</th>
                                              <th class="text-center">Adjust +-</th>
                                              <th class="text-center">Saldo Akhir</th>
                                              <th class="text-center">Summary</th>
                                              <th>#</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr v-for="d in filterData" :key="d.id">
                                              <td><b>[{{ d.product_no}}]</b> {{ d.product }}</td>
                                              <td class="text-center">
                                                <select v-model="d.uom_id" @change="setRow(d.product_no)">
                                                  <option v-for="u in d.uoms" :key="u.id" :value="u.uom_id">{{ u.uom_id }}</option>
                                                </select>
                                              </td>
                                              <td class="text-center">
                                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="d.saldo_load === false"></span>
                                                <span v-else>{{ d.saldo_awal | currency }}</span>
                                              </td>
                                              <td class="text-center">{{ d.purchasing_total | currency }}</td>
                                              <td v-for="(a, index) in d.date_summary" :key="index" class="text-center">
                                                  {{ a.qty_date | currency }} | {{ a.qty_sales | currency }}
                                              </td>
                                              <td class="text-center">
                                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="d.week_load === false"></span>
                                                <span v-else>{{ d.qty_week | currency }}</span>
                                              </td>
                                              <td class="text-center">{{ d.adjust | currency }}</td>
                                              <td class="text-center">
                                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="d.end_load === false"></span>
                                                <span v-else>{{ d.saldo_akhir | currency }}</span>
                                              </td>
                                              <td class="text-center">
                                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="d.sum_load === false"></span>
                                                <span v-if="d.saldo_akhir === d.total_sum">{{ d.total_sum | currency }}</span>
                                                <span class="badge badge-danger" v-else>{{ d.total_sum | currency }}</span>
                                              </td>
                                              <td>
                                                  <button type="button" data-toggle="modal" data-target="#modalAdjustForm" data-backdrop="static" data-keyboard="false" class="btn btn-sm btn-hard-primary" @click="createAdjust(d.product_no)">Adjust</button>
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AdjustFormModal @setAdjust="adjustReload" :proNo="proNo" :date="date"/>
        <pre>
          <!-- {{ uomList }} -->
          <!-- {{ filterData }} -->
          <!-- {{ period2 }} -->
          <!-- {{ dataRaw2 }} -->
        </pre>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { reportUrl, manufacture2Url, getHeader, setRowUrl, productUrl } from '../config'
import AdjustFormModal from '@/components/adjust/AdjustFormModal.vue'

export default {
  name: 'ManufactureReportSummaryWeekly',
  props: ['scroll'],
  components: {
    Loading,
    AdjustFormModal
  },
  data () {
    return {
      date: new Date().toISOString(),
      typeData: null,
      uomList: [],
      period: [],
      period2: [],
      dataRaw: [],
      dataRaw2: [],
      proNo: null,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: 'product_no',
      pageSize: 100,
      currentPage: 1
    }
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      manufactureTypeList: state => state.manufactures.manufactureTypeList
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    },
    filterData2 () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw2.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async setUomList () {
      await axios.get(productUrl + '/uom', { headers: getHeader() })
        .then(response => {
          this.uomList = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        header: this.period,
        header2: this.period2,
        data: this.dataRaw,
        data2: this.dataRaw2
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(manufacture2Url + '/summary-weekly', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      var obj = {
        date: this.date,
        type: this.typeData
      }
      console.log(obj)
      await axios.post(reportUrl + '/manufacture-weekly', obj, { headers: getHeader() })
        .then(response => {
          this.period = response.data.header
          this.dataRaw = response.data.data
          var arr = this.dataRaw
          for (let i = 0; i < arr.length; i++) {
            arr[i].total_sum = 0
            var uoms = this.uomList.filter(u => u.product_no === arr[i].product_no)
            arr[i].uoms = uoms
            arr[i].uom_def = arr[i].uom_id
            for (let j = 0; j < arr[i].date_summary.length; j++) {
              arr[i].date_summary[j].qty_date_def = arr[i].date_summary[j].qty_date
              arr[i].date_summary[j].qty_sales_def = arr[i].date_summary[j].qty_sales
            }
            arr[i].adjust_def = arr[i].adjust
            arr[i].saldo_akhir_def = arr[i].saldo_akhir
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        array[i].saldo_load = false
        array[i].week_load = false
        array[i].end_load = false
        array[i].sum_load = false
        await this.getSum(array[i])
        await this.getBegin(array[i])
      }
    },
    async refreshList2 () {
      this.$Progress.start()
      this.loader.isLoading = true
      var obj = {
        date: this.date,
        type: this.typeData
      }
      console.log(obj)
      await axios.post(reportUrl + '/manufacture-product-weekly', obj, { headers: getHeader() })
        .then(response => {
          this.period2 = response.data.header
          this.dataRaw2 = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async refreshAll () {
      await this.refreshList2()
      await this.refreshList()
    },
    async getSum (product) {
      const dLast = this.period.slice(-1)
      // console.log(setRowUrl + '?begin=&end=' + dLast[0].date + '&available=true&warehouse=&product_no=' + product.product_no + '&uom=' + product.uom_id)
      await axios.get(setRowUrl + '?begin=&end=' + dLast[0].date + '&available=true&warehouse=&product_no=' + product.product_no + '&uom=' + product.uom_id, { headers: getHeader() })
        .then(response => {
          var array = response.data.data
          product.total_sum = array.total.toFixed(2)
          product.total_sum_def = product.total_sum
          product.sum_load = true
        })
        .catch(error => {
          console.log(error)
          this.$swal('Error', error.message, 'error')
          throw error
        })
    },
    async getBegin (product) {
      var date = this.period.slice(0)
      var dNow = new Date(date[0].date)
      dNow.setDate(dNow.getDate() - 1)
      var end = dNow ? dNow.getFullYear() + '-' + (dNow.getMonth() + 1) + '-' + dNow.getDate() : null
      // console.log(setRowUrl + '?begin=&end=' + end + '&available=true&warehouse=&product_no=' + product.product_no + '&uom=' + product.uom_id)
      await axios.get(setRowUrl + '?begin=&end=' + end + '&available=true&warehouse=&product_no=' + product.product_no + '&uom=' + product.uom_id, { headers: getHeader() })
        .then(response => {
          var array = response.data.data
          product.saldo_awal = parseFloat(product.begin_total) + parseFloat(array.total)
          product.saldo_awal_def = product.saldo_awal
          product.saldo_load = true
          product.qty_week = parseFloat(product.qty) + parseFloat(product.return_in_total)
          product.qty_week_def = product.qty_week
          product.week_load = true
          var saldoAkhir = (parseFloat(product.saldo_awal) + (parseFloat(product.purchasing_total) - parseFloat(product.return_out_total))) - parseFloat(product.qty_week) + parseFloat(product.adjust)
          product.saldo_akhir = saldoAkhir.toFixed(2)
          product.saldo_akhir_def = product.saldo_akhir
          product.end_load = true
        })
        .catch(error => {
          console.log(error)
          this.$swal('Error', error.message, 'error')
          throw error
        })
    },
    async adjustReload () {
      await this.refreshList()
      await this.refreshList2()
    },
    createAdjust (proNo) {
      this.proNo = proNo
      // console.log(this.proNo)
    },
    async setRow (id) {
      var array = this.dataRaw.find(d => d.product_no === id)
      var arr = array.uoms.filter(u => u.uom_id === array.uom_id)
      for (let i = 0; i < arr.length; i++) {
        if (array.uom_def !== array.uom_id) {
          var ratio = arr[i].ratio
          console.log(arr[i].uom_id + ': ' + ratio + ' -> ' + arr[i].category_id)
          if (arr[i].category_id === 1) {
            array.saldo_awal = array.saldo_awal_def * ratio
            for (let j = 0; j < array.date_summary.length; j++) {
              array.date_summary[j].qty_date = array.date_summary[j].qty_date_def * ratio
              array.date_summary[j].qty_sales = array.date_summary[j].qty_sales_def * ratio
            }
            array.qty_week = array.qty_week_def * ratio
            array.adjust = array.adjust_def * ratio
            array.saldo_akhir = array.saldo_akhir_def * ratio
            array.total_sum = array.total_sum_def * ratio
          } else if (arr[i].category_id === 2) {
            array.saldo_awal = array.saldo_awal_def / ratio
            for (let j = 0; j < array.date_summary.length; j++) {
              array.date_summary[j].qty_date = array.date_summary[j].qty_date_def / ratio
              array.date_summary[j].qty_sales = array.date_summary[j].qty_sales_def / ratio
            }
            array.qty_week = array.qty_week_def / ratio
            array.adjust = array.adjust_def / ratio
            array.saldo_akhir = array.saldo_akhir_def / ratio
            array.total_sum = array.total_sum_def / ratio
          } else {
            array.saldo_awal = array.saldo_awal_def
            for (let j = 0; j < array.date_summary.length; j++) {
              array.date_summary[j].qty_date = array.date_summary[j].qty_date_def
              array.date_summary[j].qty_sales = array.date_summary[j].qty_sales_def
            }
            array.qty_week = array.qty_week_def
            array.adjust = array.adjust_def
            array.saldo_akhir = array.saldo_akhir_def
            array.total_sum = array.total_sum_def
          }
        } else {
          array.saldo_awal = array.saldo_awal_def
          for (let j = 0; j < array.date_summary.length; j++) {
            array.date_summary[j].qty_date = array.date_summary[j].qty_date_def
            array.date_summary[j].qty_sales = array.date_summary[j].qty_sales_def
          }
          array.qty_week = array.qty_week_def
          array.adjust = array.adjust_def
          array.saldo_akhir = array.saldo_akhir_def
          array.total_sum = array.total_sum_def
        }
      }
    }
  },
  mounted () {
    this.setUomList()
    this.$store.dispatch('getVendorList')
    this.$store.dispatch('getPurchasingTypeList')
    this.$store.dispatch('getTaxList')
    this.$store.dispatch('getInventoryTypeList')
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getUomList')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getProductCategoryList')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getManufactureTypeList')
    var payload = {
      status: 'order'
    }
    this.$store.dispatch('getProductListSelect', payload)
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
</style>
